import React, { useEffect } from 'react';
import { HeaderWrap, OverAllNavWrap, TrialDescription, TrialDesWrap, UserTopNavbarwrap } from './TopnavBar.style';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'redux/slices/authSlice';
import { Dropdown, Modal, Space } from 'antd';
import { resetsingleUserData, setSelectedItems } from 'redux/slices/userSlice';
import { ThemedButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import { DowmArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { resetDomainState } from 'redux/slices/selectedNodeSlice';
import ChangePassword from 'component/modal_components/password/password_form';
import { ReactComponent as KeyIcon } from 'assets/images/SVG/icons/key-icon.svg';
import { ReactComponent as LogoutIcon } from 'assets/images/SVG/icons/logout-icon.svg';
import { ReactComponent as TrialWarning } from 'assets/images/SVG/icons/trial-warning.svg';
import {
  getDomainSettingPageDetails,
  getDomainSettingPageDetailsforloginUser,
  getOuAdminRights,
  getOverrideGlobalStatusforloginUser,
  getPortalAdminRights,
  getSettingPageDetails,
} from 'redux/slices/settingsSlice';
import { resetTreeState } from 'redux/slices/treedata';
import { resetOuTreeState } from 'redux/slices/ouAdminTree';
import { setGroupSelectedItems } from 'redux/slices/getOuGroups';

export default function TopNavBar({ licenseDetails, changemodal, setChangemodal }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { changePassword, overrideGlobalStatusUser, domainsettingsDataUser } = useSelector((state) => state.settings);
  const { singleUserData } = useSelector((state) => state.getUsers);
  const trialExpired = useSelector((state) => state.licenseSlice.trialExpired);
  const userName = localStorage.getItem('userName');
  const role = localStorage.getItem('role');
  const domainId = Number(localStorage.getItem('domainId'));
  const canChangePassword = overrideGlobalStatusUser?.settings
    ? domainsettingsDataUser?.changePassword ?? true
    : changePassword ?? true;

  const dateStr = licenseDetails?.expiresAt;
  const date = new Date(dateStr);

  const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false };
  const formattedDate = date.toLocaleDateString('en-US', options);

  const handleLogout = async () => {
    await dispatch(logout());
    dispatch(resetDomainState()); // Reset the domain slice state
    dispatch(resetsingleUserData());
    dispatch(resetTreeState());
    dispatch(resetOuTreeState());
    dispatch(setSelectedItems([]));
    dispatch(setGroupSelectedItems([]));
    navigate('/login');
  };

  const handleChangePassword = () => {
    setChangemodal(true);
  };
  const handleCancel = () => {
    setChangemodal(false);
  };
  useEffect(() => {
    dispatch(getSettingPageDetails());
    dispatch(getOuAdminRights());
    dispatch(getPortalAdminRights());
  }, []);
  useEffect(() => {
    dispatch(getOverrideGlobalStatusforloginUser());
    dispatch(getDomainSettingPageDetailsforloginUser(domainId));
    dispatch(getDomainSettingPageDetails(domainId));
  }, [domainId]);

  const items = [
    (role === 'user' ? !singleUserData?.userCannotChangePassword && canChangePassword : canChangePassword) && {
      label: (
        <Link
          className='af-topbar-profile-changepassword'
          onClick={handleChangePassword}
          style={{ display: 'flex', alignItems: 'center', color: '#6c91bd' }}
        >
          <KeyIcon
            className='af-topbar-profile-changepassword-icon'
            fill='#6c91bd'
            stroke='#6c91bd'
            height={15}
            width={15}
          />
          <span
            className='af-topbar-profile-changepassword-label'
            style={{ fontSize: '14px', fontWeight: 'bold', marginLeft: '5px' }}
          >
            Change Password
          </span>
        </Link>
      ),
      key: '1',
    },
    {
      label: (
        <Link
          className='af-topbar-profile-logout'
          onClick={handleLogout}
          style={{ color: '#6c91bd', display: 'flex', alignItems: 'center' }}
        >
          <LogoutIcon className='af-topbar-profile-logout-icon' width={22} fill='#6c91bd' height={20} />
          <span className='af-topbar-profile-logout-label' style={{ fontSize: '13px', fontWeight: 'bold' }}>
            Logout
          </span>
        </Link>
      ),
      key: role === 'user' && singleUserData?.userCannotChangePassword ? '1' : canChangePassword ? '2' : '1',
    },
  ];

  const handleClick = () => {
    dispatch(resetDomainState());
    dispatch(resetTreeState());
    dispatch(resetOuTreeState());
    navigate('/adminpage');
  };

  return (
    <>
      {changemodal && (
        <Modal open={changemodal} onCancel={handleCancel} footer={[null]} centered className='af-topbar-modal'>
          <ChangePassword
            changePassUser={userName}
            setChangemodal={setChangemodal}
            changemodal={changemodal}
            userCancel={handleCancel}
          />
        </Modal>
      )}
      <OverAllNavWrap
        className='af-topbar-overall-wrap'
        style={{
          justifyContent: licenseDetails?.isTrial && licenseDetails?.isActived ? 'space-between' : 'end',
        }}
      >
        {licenseDetails?.isTrial && licenseDetails?.isActived && (
          <>
            <div className='af-topbar-freetrial' style={{ visibility: 'hidden' }}>
              Free Trial
            </div>
            <div className='af-topbar-trial-wrap'>
              <TrialDesWrap className='af-topbar-trial-des-wrap'>
                <TrialWarning width={17} className='af-topbar-trial-warning-icon' />
                <TrialDescription className='af-topbar-trial-des'>
                  {trialExpired ? trialExpired : `Your trial expires on ${formattedDate}.`}
                  &nbsp;
                  <Link
                    className='af-topbar-trial-license-link'
                    to={'https://products.dartinnovations.com/ad-web/ad-web-active-directory-management'}
                    target='_blank'
                    style={{ fontWeight: 'bold' }}
                  >
                    Buy a license
                  </Link>
                  &nbsp;to enjoy AD Web for life time.
                </TrialDescription>
              </TrialDesWrap>
            </div>
          </>
        )}

        <div className='af-topbar-profile-dropdown-wrap'>
          {role === 'user' ? (
            <UserTopNavbarwrap className='af-topbar-user-wrap'>
              <Dropdown
                menu={{
                  items,
                }}
                trigger={['click']}
                className='af-topbar-user-dropdown'
              >
                <Link onClick={(e) => e.preventDefault()} style={{ color: 'black' }} className='af-topbar-user-link'>
                  <Space style={{ height: '40px' }} className='af-topbar-user-spacewrap'>
                    <span className='username af-topbar-user-welcome'>Welcome,</span>
                    {<span className='username af-topbar-user-username'>{userName}</span>}
                    <DowmArrowIcon className='af-topbar-user-downarrow' />
                  </Space>
                </Link>
              </Dropdown>
            </UserTopNavbarwrap>
          ) : (
            <HeaderWrap className='af-topbar-admin-headerwrap'>
              <div className='af-topbar-admin-subheaderwrap'>
                <div className='af-topbar-admin-content-wrap'>
                  {!/(\/adminpage|email_template|create_domain|settings|license|customize_theme|themes|email_delivery|endpoints|brandings|api_settings)/.test(
                    location.pathname
                  ) &&
                    role === 'superadmin' && (
                      <ThemedButton
                        className='adminButton af-topbar-admin-superadmin-button'
                        style={{ marginRight: '20px' }}
                        onClick={handleClick}
                      >
                        Admin
                      </ThemedButton>
                    )}
                  {role && (
                    <Dropdown
                      menu={{
                        items,
                      }}
                      trigger={['click']}
                      className='af-topbar-admin-dropdown'
                    >
                      <Link
                        onClick={(e) => e.preventDefault()}
                        style={{ color: 'black' }}
                        className='af-topbar-admin-link'
                      >
                        <Space style={{ height: '40px' }} className='af-topbar-admin-spacewrap'>
                          <span className='username af-topbar-admin-welcome'>Welcome,</span>
                          {<span className='username af-topbar-admin-username'>{userName}</span>}
                          <DowmArrowIcon />
                        </Space>
                      </Link>
                    </Dropdown>
                  )}
                </div>
              </div>
            </HeaderWrap>
          )}
        </div>
      </OverAllNavWrap>
    </>
  );
}
